/* istanbul ignore file */

import SvgIcon from '@mui/material/SvgIcon';
import ArrowIconSrc from './icons/ArrowIcon.svg';
import markerIconSize from './constants/markerIconSize';

const BulletPointArrowIcon = () => (
  <SvgIcon component={ArrowIconSrc} width={markerIconSize} height={markerIconSize} />
);

export default BulletPointArrowIcon;
